import React, { useState, useEffect } from 'react';
import { animateScroll as scroll } from 'react-scroll';
import './scrollup.css';

const ScrollUp = () => {
    const [showScroll, setShowScroll] = useState(false);

    useEffect(() => {
        const handleScroll = () => {
            if (window.scrollY >= 560) {
                setShowScroll(true);
            } else {
                setShowScroll(false);
            }
        };

    window.addEventListener('scroll', handleScroll);

        return () => {
            window.removeEventListener('scroll', handleScroll);
        };
    }, []);

    const scrollToTop = () => {
        scroll.scrollToTop({ duration: 500, smooth: 'easeInOutQuad' });
    };

    return (
        <div
            className={`scrollup ${showScroll ? 'show-scroll' : ''}`}
            onClick={scrollToTop}
        >
            <i className="uil uil-arrow-up scrollup__icon"></i>
        </div>
    );
};

export default ScrollUp;
